// src/api/client.js
import api from "./http";

const POSTS_BASE = process.env.REACT_APP_POSTS_BASE || "/posts";

/* ------------ Helpers ------------ */
function asArray(x) {
    const d = x && x.data ? x.data : x;
    if (Array.isArray(d)) return d;
    if (Array.isArray(d?.items)) return d.items;
    if (Array.isArray(d?.rows)) return d.rows;
    return [];
}

/* ------------ Posts API (tối giản, đúng chuẩn) ------------ */
export const PostsService = {
    // GET /api/posts?status=...&limit=...
    async list(params = {}) {
        const r = await api.get(POSTS_BASE, { params });
        return asArray(r);
    },

    // POST /api/posts/:id/status?status=approved|pending|deleted|rejected
    async updateStatus(id, status) {
        if (!id) throw new Error("Missing post id");
        if (!status) throw new Error("Missing status");
        return api.post(`${POSTS_BASE}/${id}/status`, null, { params: { status } });
    },

    // DELETE /api/posts/:id
    async remove(id) {
        if (!id) throw new Error("Missing post id");
        return api.delete(`${POSTS_BASE}/${id}`);
    },
};

/* ------------ Services API (giữ nguyên) ------------ */
export const ServicesService = {
    async list(params = { limit: 1000 }) {
        const r = await api.get("/services", { params });
        return asArray(r)
            .map((s) => ({
                id: s.id ?? s.stt ?? s.code,
                name: s.name ?? s.title ?? `DV ${s.id}`,
            }))
            .filter((s) => s.id != null);
    },
};
